export const getTransformRowCells = (isPreviewMode) => {
    return [
        { name: 'input', placeholder: 'Enter input', title: 'Input', headerColumnIndex: 0 },
        { name: 'query', placeholder: 'Enter query', title: 'Query', headerColumnIndex: 1 },
        !isPreviewMode ?
            { name: 'prompt', placeholder: 'Enter instruction', title: 'Instruction', headerColumnIndex: 2 } :
            null,
        { name: 'result', placeholder: 'Enter result', title: 'Result', headerColumnIndex: 3 },
    ].filter(val => !!val);
}